import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { RouterLink } from '@angular/router';
import { ArticlesService } from '../../services/articles.service';

@Component({
  selector: 'app-home-feed',
  templateUrl: './home-feed.component.html',
  styleUrls: ['./home-feed.component.scss'],
  imports: [RouterLink]
})
export class HomeFeedComponent {
  private articleService = inject(ArticlesService);
  private destroyRef = inject(DestroyRef);

  articles: any[] = [];
  currentPost = 0;

  constructor() {
    this.getArticles();
  }

  getArticles() {
    this.articleService.getArticles('blog').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.articles = data.reverse();
      this.startRotation();
    });
  }

  private startRotation() {
    interval(5000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.currentPost = this.currentPost < this.articles.length - 1 ? this.currentPost + 1 : 0;
    });
  }
}
